// extracted by mini-css-extract-plugin
module.exports = {"buttonText":"PickBest_buttonText__2GZHc"};